export const LINK_TEXT = 'See Users without Classes'
export const MANY_USERS_DESCRIPTION_TEXT = 'Users with Classes'
export const SINGLE_USER_DESCRIPTION_TEXT = 'User with Classes'
export const TRAINING_DESCRIPTION_TEXT = 'Training Progress'
export const TRAINING_REPORT_LINK_TEXT = 'Go to Report'
